import { AnyAction } from 'redux';
import { ILoadingError } from '#/types/global';
import { IArtistAlbums } from '#/types/API/artists';
import {
  createActionArtistAppearsOnError,
  createActionArtistAppearsOnReset,
  createActionArtistAppearsOnSetApearsOn,
  createActionArtistAppearsOnStartLoading,
  createActionArtistAppearsOnStopLoading,
} from '../actions/artistAppearsOn';

export interface IArtistApearsOn {
  appearsOn?: IArtistAlbums;
}

type TState = IArtistApearsOn & ILoadingError;

const initialState: TState = { _loading: true, _error: false };

const artistAppearsOn = (
  state: TState = initialState,
  action: AnyAction
): TState => {
  if (createActionArtistAppearsOnSetApearsOn.doesMatch(action)) {
    return { ...state, appearsOn: action.payload };
  }

  if (createActionArtistAppearsOnStartLoading.doesMatch(action)) {
    return { ...state, _loading: true };
  }

  if (createActionArtistAppearsOnStopLoading.doesMatch(action)) {
    return { ...state, _loading: false };
  }

  if (createActionArtistAppearsOnError.doesMatch(action)) {
    return { ...state, _error: true };
  }

  if (createActionArtistAppearsOnReset.doesMatch(action)) {
    return initialState;
  }

  return state;
};

export default artistAppearsOn;
